// Only copy values recorded on the listing; missing values remain editable blanks.
export const emptyRoomFields = {
  roomCode: '',
  projectAddress: '', rent: '', rentalMonths: '', occupants: '', vehicles: '',
  electricity: '', water: '', parking: '', management: '', otherFee: '',
  totalDeposit: '', depositAmount: '', additionalDeposit: '',
};

export const calculateAdditionalDeposit = (total, holding) => {
  if (total === '' || holding === '' || total == null || holding == null) return '';
  const amount = Number(total) - Number(holding);
  return Number.isFinite(amount) ? String(Math.max(0, amount)) : '';
};

export const getDepositRoomFields = (room) => {
  const legacy = {};
  const labels = {
    'Phí điện': 'electricity', 'Phí nước': 'water', 'Phí gửi xe': 'parking',
    'Phí dịch vụ': 'serviceFee', 'Phí khác': 'otherFee', 'Hợp đồng': 'contractMonths',
    'Số xe tối đa': 'maxVehicles', 'Cọc giữ chỗ': 'reservationFee', 'Số tiền cọc': 'reservationFee',
    'Cọc': 'depositMonths',
    'Tên chủ nhà': 'ownerName', 'SĐT chủ nhà': 'ownerPhone',
    'Số tiền cần bổ sung': 'additionalDeposit',
  };
  String(room.description || '').split(/\r?\n/).forEach((line) => {
    const match = line.match(/^\s*([^:]+):\s*(.*?)\s*$/u);
    if (match && labels[match[1]]) legacy[labels[match[1]]] = match[2].replace(/\s+tháng$/u, '');
  });
  let details = room.details || {};
  if (typeof details === 'string') {
    try { details = JSON.parse(details); } catch { details = {}; }
  }
  details = { ...legacy, ...(details && typeof details === 'object' ? details : {}) };
  const value = (input) => input === null || input === undefined ? '' : String(input).trim();
  const money = (input) => {
    let text = value(input).replace(/\s|VNĐ|VND/gi, '');
    if (!text) return '';
    if (/^\d{1,3}([.,]\d{3})+$/.test(text)) text = text.replace(/[.,]/g, '');
    return Number.isFinite(Number(text)) && Number(text) >= 0 ? String(Number(text)) : '';
  };
  const recordedDeposit = [details.reservationFee, details.totalDeposit, legacy.reservationFee]
    .map(money).find((amount) => amount !== '');
  const months = value(details.depositMonths);
  const price = money(room.price);
  const totalDeposit = recordedDeposit ?? (months !== '' && price !== '' && Number.isFinite(Number(months)) && Number(months) >= 0
    ? String(Number(price) * Number(months)) : '');
  return {
    roomCode: value(details.roomCode),
    projectAddress: value(room.address),
    rent: money(room.price),
    rentalMonths: value(details.contractMonths),
    occupants: value(room.capacity),
    vehicles: value(details.maxVehicles),
    electricity: value(details.electricity),
    water: [value(details.water), value(details.water) ? value(details.waterUnit) : ''].filter(Boolean).join(' '),
    parking: value(details.parking),
    management: value(details.serviceFee),
    otherFee: value(details.otherFee),
    totalDeposit,
    depositAmount: '',
    additionalDeposit: '',
  };
};
